import { Button, Input, MagellanPopup } from 'components/atoms';
import GenreSelectCard from 'components/molecules/card/genre-select/GenreSelectCard';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { useGetGenres } from 'services/enums';
import { GENRE } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface IGenrePopupFormProps {
  trigger?: JSX.Element | ((isOpen: boolean) => JSX.Element) | undefined;
  onSelectGenre?: (genre: GENRE | null, actions: PopupActions) => void;
  open?: boolean;
  initialGenre?: GENRE | null;
  displayMode?: boolean;
}

const GenrePopupForm = ({
  trigger,
  onSelectGenre,
  open,
  initialGenre = null,
  displayMode,
}: IGenrePopupFormProps) => {
  const popupRef = useRef<PopupActions | null>(null);
  const { t } = useTranslation();

  const [genreSearch, setGenreSearch] = useState('');
  const [selectedGenre, setSelectedGenre] = useState<GENRE | null>(null);

  const genres = useGetGenres();

  return displayMode ? (
    <>{trigger}</>
  ) : (
    <Popup
      ref={popupRef}
      open={displayMode === false ? false : open}
      onOpen={() => {
        setSelectedGenre(initialGenre);
      }}
      onClose={() => {
        setSelectedGenre(null);
        setGenreSearch('');
      }}
      modal
      nested
      trigger={trigger}
    >
      <MagellanPopup>
        <MagellanPopup.Header>{t('input.label.genre')}</MagellanPopup.Header>

        <Input.Text
          value={genreSearch}
          onChange={(e) => setGenreSearch(e.target.value)}
          name=""
          appBackground
          placeholder={t('input.placeholder.search-genre')}
        />
        <div className="flex flex-col w-full max-w-96 overflow-auto h-[450px] [scrollbar-width:none]  gap-2">
          {genres.data
            ?.filter((genre) =>
              t(`genre.${genre}.name`).toLowerCase().includes(genreSearch.toLowerCase()),
            )
            .map((genre) => (
              <GenreSelectCard
                key={genre.id}
                genre={genre.id}
                isSelected={selectedGenre === genre.id}
                onClick={(newGenre) =>
                  setSelectedGenre((prev) => (prev === newGenre ? null : newGenre))
                }
              />
            ))}
        </div>
        <div className="flex justify-between w-full">
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t('button.cancel')} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.submit}
            onClick={() =>
              popupRef.current && onSelectGenre && onSelectGenre(selectedGenre, popupRef.current)
            }
          >
            <Button.Text text={t('button.save')} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default GenrePopupForm;
